import React, { useMemo, useState } from 'react';
import { Link, useNavigate, useSearchParams } from 'react-router-dom';
import { FiLock, FiEye, FiEyeOff } from 'react-icons/fi';
import toast from 'react-hot-toast';
import { authAPI } from '../../services/api';
import Logo from '../../components/Logo/Logo';
import '../Login/Auth.css';

const ResetPassword = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const token = useMemo(() => searchParams.get('token') || '', [searchParams]);

  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!token) {
      toast.error('Falta el token de restablecimiento');
      return;
    }

    if (!password || password.length < 8) {
      toast.error('La contraseña debe tener al menos 8 caracteres');
      return;
    }

    if (password !== confirmPassword) {
      toast.error('Las contraseñas no coinciden');
      return;
    }

    try {
      setLoading(true);
      await authAPI.resetPassword(token, password);
      toast.success('Contraseña actualizada. Ya puedes iniciar sesión.');
      navigate('/login');
    } catch (error) {
      console.error('Reset password error:', error);
      toast.error(error.response?.data?.message || 'No se pudo restablecer la contraseña');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-container">
        <div className="auth-card">
          <div className="auth-header">
            <Logo size="large" showText={true} />
            <h1 className="auth-title">Nueva contraseña</h1>
            <p className="auth-subtitle">Crea una contraseña nueva para tu cuenta.</p>
          </div>

          {!token ? (
            <div className="auth-form">
              <p className="auth-subtitle">El enlace no es válido o falta el token.</p>
              <Link to="/forgot-password" className="link-primary">
                Solicitar un nuevo enlace
              </Link>
            </div>
          ) : (
            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label className="form-label">Contraseña</label>
                <div className="input-wrapper">
                  <span className="input-icon-wrapper">
                    <FiLock className="input-icon" />
                  </span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-input"
                    placeholder="••••••••"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                  <button
                    type="button"
                    className="input-toggle"
                    onClick={() => setShowPassword((v) => !v)}
                  >
                    {showPassword ? <FiEyeOff /> : <FiEye />}
                  </button>
                </div>
              </div>

              <div className="form-group">
                <label className="form-label">Confirmar contraseña</label>
                <div className="input-wrapper">
                  <span className="input-icon-wrapper">
                    <FiLock className="input-icon" />
                  </span>
                  <input
                    type={showPassword ? 'text' : 'password'}
                    className="form-input"
                    placeholder="••••••••"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                    required
                  />
                </div>
              </div>

              <button type="submit" className="btn btn-primary btn-block" disabled={loading}>
                {loading ? 'Guardando...' : 'Guardar contraseña'}
              </button>

              <p className="auth-footer">
                <Link to="/login" className="link">
                  Volver a iniciar sesión
                </Link>
              </p>
            </form>
          )}
        </div>

        <div className="auth-visual">
          <div className="visual-overlay"></div>
          <div className="visual-content">
            <h2>Seguridad primero</h2>
            <p>El enlace expira automáticamente por seguridad.</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ResetPassword;
